// extracted by mini-css-extract-plugin
export var black = "_49-6";
export var brand = "_49-1";
export var ddefault = "_49-0";
export var error = "_49-3";
export var gray = "_49-2";
export var highContrast = "_49-8";
export var outline = "_49-7";
export var success = "_49-5";
export var warning = "_49-4";